import React from "react"
import { Helmet } from "react-helmet"
// import Header from "../Header/Header"
// import Footer from "../Footer/Footer"
import { RecruitHeader,RecruitFooter } from "../Recruit/index";
// import "../../styles/style.scss"
// import "@wordpress/block-library/build-style/style.css"
// import "@wordpress/block-library/build-style/theme.css"
import { PageTopButton } from "../index"

const RecruitLayout = ({ pageName, className, children, title }) => {
  return (
    <>
      <Helmet>
        <link rel="dns-prefetch" href="//fonts.googleapis.com/" />
        <link rel="dns-prefetch" href="//fonts.gtatic.com/" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        {/* <script defer src="https://polyfill.io/v3/polyfill.min.js?features=fetch%2CPromise"></script> */}
      </Helmet>
      <div className={`LayoutWrapper`}>
        <RecruitHeader pageName={pageName} />
        <main className={className}>
          {children}
        </main>
        <RecruitFooter pageName={pageName} title={title} />
        <PageTopButton />
      </div>
    </>
  )
}

export default RecruitLayout